import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import "../Miscellaneous/NavigationBar.css";
import menuIcon from "../../assets/NavgigationBarImages/Menu.png";

import closeIcon from "../../assets/NavgigationBarImages/cr2.svg";
import fb from "../../assets/NavgigationBarImages/fb1.png";
import linkedin from "../../assets/NavgigationBarImages/Layer 1.png";
import blackSocialMedia from "../../assets/NavgigationBarImages/blackSocialMedia.png";

import insta from "../../assets/NavgigationBarImages/in1.png";
// import logoblack from "../../assets/NavgigationBarImages/whit.png";
import FooterLogo from "../../assets/PortfolioImages/NewLogo.svg";
import WhiteLogo from "../../assets/PortfolioImages/WhiteLogo.svg";

import logo from "../../assets/FooterImages/LOGO PNG.svg";

// import logowhite from "../../assets/NavgigationBarImages/whit.png";
import { useLocation, useNavigate } from "react-router-dom";

const NavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let logoToUse = logo;

  const openGoogleMaps = () => {
    window.open(
      "https://www.google.com/maps/place/25°17'47.4%22N+55°38'14.0%22E/@25.2964916,55.6346321,17z/data=!3m1!4b1!4m4!3m3!8m2!3d25.2964916!4d55.637207?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D",
      "_blank",
      "noopener,noreferrer",
    );
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const goToBbqArea = () => {
    navigate("/bbq-area/");
    setShow(false);
  };

  const goToCNCPanelCutter = () => {
    navigate("/cnc-panel-cutter/");
    setShow(false);
  };

  const goToPergolas = () => {
    navigate("/pergolas/");
    setShow(false);
  };

  const goToGlassRooms = () => {
    navigate("/glass-rooms/");
    setShow(false);
  };

  const goToCarParkingPergolas = () => {
    navigate("/car-parking-shades/");
    setShow(false);
  };

  const goToAluminiumDoors = () => {
    navigate("/aluminium-doors/");
    setShow(false);
  };
  const goToSmartPergola = () => {
    navigate("/smart-pergola/");
    setShow(false);
  };

  const goToHome = () => {
    navigate("/");
    setShow(false);
  };

  const goToAboutUs = () => {
    navigate("/about-us/");
    setShow(false);
  };

  function handleClick() {
    const element = document.getElementById("contact-us");
    if (element) {
      const offsetTop = element.offsetTop;
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
    setShow(false);
  }
  const whiteLogoPages = [
    "/about-us/",
    "/pergolas/",
    "/glass-rooms/",
    "/bbq-area/",
    "/cnc-panel-cutter/",
    "/aluminium-doors/",
    "/car-parking-shades/",
  ];

  logoToUse = whiteLogoPages.includes(location.pathname) ? WhiteLogo : logo;

  return (
    <>
      <Navbar
        className="myClass"
        style={{
          backgroundColor: "transparent",
          zIndex: "100",
        }}
      >
        <Container className="py-2">
          <Navbar.Brand href="/" className="font-face-rb">
            <img
              src={logoToUse}
              className="img-fluid"
              style={{ maxWidth: "105px" }}
              loading="lazy"
            />
          </Navbar.Brand>

          <div className="icons">
            <img
              onClick={handleShow}
              src={menuIcon}
              alt="menuIcon"
              className="ms-3"
              loading="lazy"
            />
          </div>
        </Container>
      </Navbar>

      <Offcanvas show={show} placement="top">
        <Offcanvas.Header>
          <Offcanvas.Title>
            <img
              src={FooterLogo}
              className="img-fluid"
              style={{ maxWidth: "110px" }}
              onClick={goToHome}
              loading="lazy"
            />
          </Offcanvas.Title>
          <div className="icons">
            <span className="font-face-rr">Close</span>
            <img
              src={closeIcon}
              alt="close"
              className="ms-2"
              style={{ maxWidth: "34px" }}
              onClick={handleClose}
              loading="lazy"
            />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div id="Floating-Menu" className="container">
            <div className="row">
              <div className="first col-lg-2 font-face-rb ">
                Call Us <br />
                <small className="font-face-rr">+971565443552</small>
              </div>
              <div className="second col-lg-2 pb-2 font-face-rb ">
                Email Us <br />
                <small className="font-face-rr">info@pergolasroom.ae</small>
              </div>
              <div className="third col-lg-3 pb-2 font-face-rb ">
                Visit Us
                <br />
                <small className="font-face-rr " style={{ cursor: "default" }}>
                  Dubai, United Arab Emirates
                </small>
                <br />
                <small className="font-face-rr" onClick={openGoogleMaps}>
                  Sharjah, United Arab Emirates
                </small>
              </div>
              <div id="nav-List" className="col-lg-5">
                <ul className="items font-face-rb" onClick={goToHome}>
                  Home
                </ul>
                <ul className="items font-face-rb" onClick={goToAboutUs}>
                  About
                </ul>
                <ul className="items font-face-rb" onClick={goToSmartPergola}>
                  Smart Pergola
                </ul>
                <ul className="items font-face-rb" onClick={goToPergolas}>
                  Pergolas
                </ul>
                <ul className="items font-face-rb" onClick={goToGlassRooms}>
                  Glass Rooms
                </ul>

                <ul className="items font-face-rb" onClick={goToBbqArea}>
                  Bar & BBQ Counters
                </ul>

                <ul className="items font-face-rb" onClick={goToCNCPanelCutter}>
                  CNC Cut Panel
                </ul>

                <ul className="items font-face-rb" onClick={goToAluminiumDoors}>
                  Doors & Fences
                </ul>

                <ul
                  className="items font-face-rb"
                  onClick={goToCarParkingPergolas}
                >
                  Car Parking Pergolas
                </ul>

                <nav>
                  <ul className="items font-face-rb" onClick={handleClick}>
                    Contact
                  </ul>
                </nav>
              </div>
            </div>
            <hr className="Horizontal-line mt-5" />

            <span className="font-face-rr">Follow Us</span>
            <div className="floating-icons py-2 d-flex flex-row">
              <a
                href="https://www.facebook.com/share/15WeXH4Xz8/?mibextid=wwXIfr"
                target="_blank"
              >
                <img className="pb-2 ms-2" src={fb} alt="fb" loading="lazy" />
              </a>
              <a
                href="https://www.instagram.com/pergolarooms.ae?igsh=eTBtOWM2dmdsbXQ="
                target="_blank"
              >
                <img
                  className="pb-2 ms-2"
                  src={insta}
                  alt="insta"
                  loading="lazy"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/pergola-rooms-building-contracting-llc/?viewAsMember=true"
                target="_blank"
              >
                <img
                  className="pb-2 ms-2"
                  src={linkedin}
                  alt="fb"
                  loading="lazy"
                />
              </a>
              <a href="https://x.com/pergolarooms?s=21" target="_blank">
                <img
                  className="pb-2 ms-2"
                  src={blackSocialMedia}
                  alt="fb"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default NavigationBar;
